import type Luminary from '@lumen5/luminary';

import type { LintFinding } from '../videoLinter';

/**
 * Error: the video has no scenes. A video with no scenes has nothing to
 * display, so the entire preview is blank until at least one scene is added.
 * This is always a hard defect, never intentional for a finished video.
 */
export function checkNoScenes(luminary: Luminary): LintFinding[] {
    if (luminary.scenes.length > 0) {
        return [];
    }

    return [
        {
            check: 'no_scenes',
            severity: 'error',
            message:
                "This video has no scenes, so there's nothing to display — the whole preview stays blank until you add at least one scene.",
        },
    ];
}
